import type { ICellRendererParams } from 'ag-grid-community';
import { Chip } from 'Components/atoms';
import React from 'react';
import type { Employee } from './usersTable';

const UsersTopRiskContributorsCellRenderer: React.FC<ICellRendererParams<Employee, string[]>> = (params) => {
  const row = params.data;
  const list = row?.topRiskContributors ?? [];
  const contributors = Array.from(new Set(list)).sort();

  if (!row || contributors.length === 0) {
    return <span>-</span>;
  }

  return (
    <div className="d-flex gap-1 flex-wrap align-items-center h-100">
      {contributors.map((label) => (
        <Chip value={label} variant="top_risk_issue" key={label} />
      ))}
    </div>
  );
};

export default UsersTopRiskContributorsCellRenderer;
